var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgListIconEditSolid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13C13.7761 13 13.9999 13.2239 14 13.5C14 13.7761 13.7761 14 13.5 14H2.5C2.22386 14 2 13.7761 2 13.5C2.00005 13.2239 2.22389 13 2.5 13H13.5ZM8.57031 4.16016C8.88262 4.74801 9.34212 5.49054 9.92578 6.07422C10.5095 6.6579 11.252 7.11737 11.8398 7.42969L8.04004 11.2295C7.80426 11.4652 7.49804 11.6179 7.16797 11.665L4.87988 11.9922C4.37133 12.0648 3.93516 11.6287 4.00781 11.1201L4.33496 8.83203C4.38211 8.50196 4.53476 8.19574 4.77051 7.95996L8.57031 4.16016ZM10.2793 2.45117C10.8811 1.84948 11.8572 1.84946 12.459 2.45117L13.5488 3.54102C14.1506 4.14283 14.1506 5.11884 13.5488 5.7207L12.582 6.68652C12.5063 6.64903 12.4263 6.6089 12.3438 6.56543C11.7868 6.27222 11.126 5.8604 10.6328 5.36719C10.1396 4.87395 9.72777 4.21317 9.43457 3.65625C9.39108 3.57363 9.35099 3.49371 9.31348 3.41797L10.2793 2.45117Z",
    fill: "#414651"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgListIconEditSolid);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/list_icon_edit_solid.0cca26c3bfd8d2f420860e226ad4edbd.svg";